'use client';

export const Document = ({ className, ...props }: React.ComponentPropsWithoutRef<'svg'>) => {
	return (
		<svg
			width="32"
			height="32"
			viewBox="0 0 32 32"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			className={className}
			{...props}
		>
			<path
				d="M7.30484 30C6.67165 30 6.12921 29.7742 5.67753 29.3225C5.22584 28.8708 5 28.3284 5 27.6952V4.30484C5 3.67165 5.22584 3.12921 5.67753 2.67753C6.12921 2.22584 6.67165 2 7.30484 2H18.7893C19.1051 2 19.4054 2.06239 19.6901 2.18716C19.9745 2.31193 20.2224 2.47686 20.4339 2.68195L26.4233 8.67137C26.6284 8.88284 26.7933 9.13079 26.9181 9.41521C27.0429 9.69988 27.1053 10.0001 27.1053 10.316V27.6952C27.1053 28.3284 26.8794 28.8708 26.4277 29.3225C25.9761 29.7742 25.4336 30 24.8004 30H7.30484ZM18.8169 9.08105V3.85168H7.30484C7.19161 3.85168 7.08772 3.89884 6.99316 3.99316C6.89884 4.08772 6.85168 4.19161 6.85168 4.30484V27.6952C6.85168 27.8084 6.89884 27.9123 6.99316 28.0068C7.08772 28.1012 7.19161 28.1483 7.30484 28.1483H24.8004C24.9136 28.1483 25.0175 28.1012 25.1121 28.0068C25.2064 27.9123 25.2536 27.8084 25.2536 27.6952V10.2338H19.9693C19.6466 10.2338 19.3738 10.1225 19.1511 9.89968C18.9283 9.67667 18.8169 9.40379 18.8169 9.08105Z"
				fill="currentColor"
			/>
		</svg>
	);
};
